import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'changebanque'
})
export class changebanquePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    console.log(value)
    if (value === '00110') {
      return 'banque1';
    } else if (value === '00108') {
      return 'banque2';
    } else if (value) {
      return 'banque3';
    } else {
      return ''; // Return empty string for undefined or null values
    }
  }
}
